import { useField } from 'formik'
import styles from './inputs.module.scss'

const CustomInput = ({ label, maxLength, type = 'text', ...props }) => {
  const [field, meta] = useField(props)
  const customClass = props.className === undefined ? "" : `${props.className} `
  const charCount = field.value ? String(field.value).length : 0
  const isOverLimit = maxLength && charCount >= maxLength

  const handleKeyDown = type === 'number'
    ? (e) => { if (['e', 'E', '+', '-'].includes(e.key)) e.preventDefault() }
    : undefined

  return (
    <div className="d-flex flex-column">
      <label className={styles.label} htmlFor="in">{label}
        <input
          {...field} cuso
          {...props}
          type={type}
          maxLength={type !== 'number' ? maxLength : undefined}
          onKeyDown={handleKeyDown}
          className={meta.touched && meta.error ? customClass + styles.inputError : customClass}
          id="in"
        />
        {maxLength && type !== 'number' && (
          <span style={{ fontSize: 11, textAlign: 'right', color: isOverLimit ? '#c0392b' : '#888', marginTop: 2, display: 'block' }}>
            {charCount}/{maxLength}
          </span>
        )}
        {meta.touched && meta.error && (
          <div className={styles.error}>{meta.error}</div>
        )}
      </label>

    </div>
  )
}
export default CustomInput
